import Error from '@material-ui/icons/ErrorOutline';

import styles from './FieldError.module.scss';

export const FieldError = ({ errorMessage }: { errorMessage?: string }) => {
  if (!errorMessage) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.iconContainer} aria-hidden>
        <Error fontSize="small" />
      </div>
      <span className={styles.error}>{errorMessage}</span>
    </div>
  );
};

export default FieldError;
